<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div class="modalWrapper kingdomEventNotification" style="opacity: 1; align-items: center; justify-content: center; display: flex; width: 100%; height: 100%;">
			<div class="modal small  kingdomEventNotification " ng-class="{inWindowPopupOpened: inWindowPopupOpened}" style="top: 0;">
				<!-- ngIf: ::w.params.modalParams.backgroundFlare -->
				<div class="modalContent" ng-style="{minHeight: w.getOverlayHeightWithPadding(-10) || 'none'}">
					<div class="functionPanel">
						<a @click="onModalClose(close)" @mouseover="cancelHover = true" @mouseleave="cancelHover = false" class="closeWindow clickable" play-on-click="7">
							<i :class="['closeWindow', {action_cancel_small_flat_black: !cancelHover, action_cancel_small_flat_green: cancelHover}]"></i>
						</a>
					</div>
					<div class="contentHeader">
						<h2 ng-if="!w.contentHeaderText" ng-class="::{static: w.params.modalParams.staticPosition}" class=" msAntiScroll" draggable="true">
							<span translate="" data="" options="Notification.KingdomEvent.Title"><span>Событие королевства</span></span>
						</h2>
						<!-- ngIf: w.contentHeaderText -->
					</div>
					<div ng-controller="kingdomEventNotificationCtrl" class="kingdomEvent">
						<div ng-if="events[displayedEventNr].time" class="eventTime">
							<span i18ndt="1729935867" format="shortDate">Сегодня</span> |
							<span i18ndt="1729935867" format="mediumTime">14:44:27</span>
						</div>
						<div class="eventNavigation">
							<div ng-show="events[displayedEventNr-1]" clickable="displayEvent(displayedEventNr-1)" translate="" class="clickable ng-hide"><span>Новые</span></div>
							<div ng-show="events[displayedEventNr+1]" clickable="displayEvent(displayedEventNr+1)" translate="" class="clickable ng-hide"><span>Старые</span></div>
						</div>
						<div class="notificationBody promotion">
							<div class="playerProfileAvatar kingdomRole2" ng-repeat="player in events[displayedEventNr].player">
								<div class="headerWithArrowEndings kingdomRole kingdomRole2">
									<div class="content"><a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable disabled" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" nolink="true" playerid="1152">нико</a></div>
								</div>
								<div class="avatarLink clickable" clickable="openWindow('profile', {'playerId': 1152 }, null, true);">
									<avatar-image scale="0.55" class="avatarImage" player-id="1152" size="big" avatar-class="profileImage">
										<div class="heroImage  profileImage female" ng-class="::class" rerender="rerender">
											<!-- ngIf: playerId == robberId -->
											<!-- ngIf: playerId == npcGovernorId -->
											<canvas width="192" height="192"></canvas>
										</div>
									</avatar-image>
									<div class="prestigeStars" ng-if="config.balancing.features.prestige">
										<div class="innerStars" playerid="1152" size="tiny">
											<div ng-if="!badge">
												<i class="prestigeStar prestige_starGold_tiny_illu"></i>
												<i class="prestigeStar prestige_starGold_tiny_illu"></i>
												<i class="prestigeStar prestige_starGold_tiny_illu"></i>
											</div>
											<!-- ngIf: badge -->
										</div>
									</div>
								</div>
								<span class="decoration"></span>
							</div>
						</div>
						<div ng-if="events.length > 0" class="notificationFooter">
							<div class="eventText" options="107,2,0" data="playerId1:1152,playerId2:,kingdomName:русь" translate=""><span>Игрок </span><a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="truncated playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" playerid="1152" playername="" nolink="" showmissinglink="true">нико</a><span> получил титул герцога</span></div>
							<!-- ngIf: events[displayedEventNr].info -->
						</div>
					</div>
					<div class="window-overlay" name="smallOverlay"></div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>